// Suppress THREE.Clock deprecation warning from @react-three/fiber internals (v9.5.0)
// R3F still uses Clock; no newer version available. Safe to ignore.
const _origWarn = console.warn
console.warn = (...args: unknown[]) => {
  if (typeof args[0] === 'string' && args[0].includes('Clock')) return
  _origWarn.apply(console, args)
}

import {StrictMode} from 'react'
import {createRoot} from 'react-dom/client'
import {HelmetProvider} from 'react-helmet-async'
import {ThemeProvider, CssBaseline} from '@mui/material'
import {Provider} from 'react-redux'
import {createAppTheme} from './theme'
import '../common/utils/roundRectPolyfill'
import {store} from '../common/store'
import {AuthProvider} from './auth/AuthContext.tsx'
import {ToastProvider} from '../common/components/toast/ToastProvider'
import '../common/cookieConsent/store'
import {initSentryIfConsented} from '../common/errors/sentry'
import {initGaIfConsented} from '../common/analytics/ga'
import {logVersions} from '../common/utils/logVersions'
import AppErrorBoundary from './components/errorBoundary/AppErrorBoundary'
import CookieConsentBanner from './components/CookieConsentBanner.tsx'
import './i18n'
import App from './App.tsx'

initSentryIfConsented('gui')
initGaIfConsented('gui')
logVersions()

const theme = createAppTheme('dark')

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <HelmetProvider>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <ToastProvider>
            <AuthProvider>
              <AppErrorBoundary>
                <App />
                <CookieConsentBanner />
              </AppErrorBoundary>
            </AuthProvider>
          </ToastProvider>
        </ThemeProvider>
      </Provider>
    </HelmetProvider>
  </StrictMode>,
)
